import { MetricsSwitch } from '../../shared/model/metric';
import { DefaultMetricType } from '../../shared/model/types';

export const DefaultMeticOptions: Array<DefaultMetricType> = [
  {
    label: 'signals-ng-visualization-tab.metricSwitch.signalCount',
    value: MetricsSwitch.COUNT
  },
  {
    label: 'signals-ng-visualization-tab.metricSwitch.relevance',
    value: MetricsSwitch.RELEVANCE_SUM
  },
  {
    label: 'signals-ng-visualization-tab.metricSwitch.averageRelevance',
    value: MetricsSwitch.RELEVANCE_AVG
  },
  {
    label: 'signals-ng-visualization-tab.metricSwitch.countLogAndRelevance',
    value: MetricsSwitch.COUNT_LOG_AND_RELEVANCE
  },
  {
    label: 'signals-ng-visualization-tab.metricSwitch.smartRelevance',
    value: MetricsSwitch.SMART_RELEVANCE
  },
  {
    label: 'signals-ng-visualization-tab.metricSwitch.dumbBiasCorrection',
    value: MetricsSwitch.DUMB_BIAS_CORRECTION
  },
  {
    label: 'signals-ng-visualization-tab.metricSwitch.normalizedBiasCorrection',
    value: MetricsSwitch.NORMALIZED_BIAS_CORRECTION
  },
  {
    label: 'signals-ng-visualization-tab.metricSwitch.countLogAndSmartRelevance',
    value: MetricsSwitch.SMART_RELEVANCE_WITH_COUNT
  },
  {
    label: 'signals-ng-visualization-tab.metricSwitch.countLogAndDumbBiasCorrection',
    value: MetricsSwitch.DUMB_BIAS_CORRECTION_WITH_COUNT
  },
  {
    label: 'signals-ng-visualization-tab.metricSwitch.countLogAndNormalizedBiasCorrection',
    value: MetricsSwitch.NORMALIZED_BIAS_CORRECTION_WITH_COUNT
  },
  {
    label: 'signals-ng-visualization-tab.metricSwitch.countLogAndTopicScore',
    value: MetricsSwitch.COUNT_LOG_AND_TOPIC_SCORE
  }
];
